import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

function SFRMetadata({ placeName, coordinates }) {
  const { t } = useTranslation();

  const downloadDate = new Date().toLocaleString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });

  const latitude = Array.isArray(coordinates) ? coordinates[0] : coordinates?.lat;
  const longitude = Array.isArray(coordinates) ? coordinates[1] : coordinates?.lng;
  const hasValidCoordinates = Number.isFinite(latitude) && Number.isFinite(longitude);

  return (
    <View
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Text style={styles.subtitle}>
        {`${t("pdf.generatedFor")} ${placeName}`}
        {"\n"}
        {hasValidCoordinates && (
          <Text style={styles.subtitle}>
            {latitude.toFixed(5)}°N, {longitude.toFixed(5)}°E
          </Text>
        )}
      </Text>

      <Text style={styles.downloadDate}>{downloadDate}</Text>
    </View>
  );
}

export default SFRMetadata;

const styles = StyleSheet.create({
  subtitle: {
    fontSize: 11,
    color: "#6b7280",
  },
  downloadDate: {
    fontSize: 10,
    color: "#9ca3af",
  },
});
